import React, {
  useState,
  useEffect,
  // useRef,
  // useCallback,
  useMemo,
} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Grid,
  Typography,
  Paper,
  InputAdornment,
  Stack,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import Webcam from "react-webcam";
import Keypad from "../../../components/Keypad";
// import { SALENG_SHOP_API_PROD } from "../../../config";
// import { useTheme } from "@mui/material/styles";
import { formatNumber } from "../../../utils/formatNumber";

// const SALENG_SHOP_API = SALENG_SHOP_API_PROD;

export default function ProductScaleDialog({ open, onClose, onConfirm, init }) {
  // const theme = useTheme();

  const [weight, setWeight] = useState(0);
  const [deduct, setDeduct] = useState(0);
  const [stock, setStock] = useState(0);
  const [inputValue, setInputValue] = useState(0);
  const [dialogSide, setDialogSide] = useState("left");
  const [focused, setFocused] = useState("weight"); // "weight" | "deduct"

  // const webcamRef = useRef(null);

  const sanitizeNumber = (s) => {
    if (s == null || s === "") return "0";
    let x = String(s).replace(/[^\d.]/g, "");
    const parts = x.split(".");
    if (parts.length > 2) x = parts[0] + "." + parts.slice(1).join("");
    if (/^0+\d/.test(x)) x = x.replace(/^0+/, "");
    return x === "" ? "0" : x;
  };

  const netNumber = useMemo(() => {
    const h = parseFloat(weight || "0");
    const l = parseFloat(deduct || "0");
    const n = h - l;
    return Number.isNaN(n) ? 0 : n;
  }, [weight, deduct]);

  const isNetNegative = netNumber < 0;

  const resetForm = () => {
    setWeight(0);
    setDeduct(0);
    setInputValue(0);
    setFocused("weight");
  };

  // ---------- sync จาก transactioån ----------
  useEffect(() => {
    console.log('init',init);
    setDialogSide(init?.dialogSide != null ? init.dialogSide : "left");
    setStock(init?.stock != null ? init.stock : 0);
    setWeight(init?.total != null ? init.total : 0);
    setDeduct(init?.rest != null ? init.rest : 0);
  }, [init]);

  // ---------- sync keypad ตามช่องที่โฟกัส ----------
  useEffect(() => {
    setInputValue(focused === "deduct" ? deduct || "0" : weight || "0");
  }, [focused, weight, deduct]);

  // ---------- กล้อง & อัปโหลด ----------
  //   const captureImage = useCallback(async () => {
  //     if (!webcamRef.current) return null;
  //     const video = webcamRef.current.video;
  //     if (!video || video.readyState < 2) return null;

  //     const canvas = document.createElement("canvas");
  //     canvas.width = 1920;
  //     canvas.height = 1080;
  //     const ctx = canvas.getContext("2d");
  //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //     const imageSrc = canvas.toDataURL("image/jpeg", 1);
  //     if (!imageSrc) return null;

  //     const blob = await (await fetch(imageSrc)).blob();
  //     return new File([blob], "webcam_photo.jpg", { type: "image/jpeg" });
  //   }, []);

  //   async function uploadFile(file) {
  //     if (!file) throw new Error("No file to upload");
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     const response = await fetch(SALENG_SHOP_API + "/files", {
  //       method: "POST",
  //       body: formData,
  //     });
  //     if (!response.ok) throw new Error("Upload failed: " + response.statusText);
  //     const result = await response.json();
  //     return result;
  //   }

  const handleConfirm = async () => {
    resetForm();
    // let imageUrl = null;
    // try {
    //   const capturedImage = await captureImage();
    //   if (capturedImage) {
    //     const uploadResult = await uploadFile(capturedImage);
    //     imageUrl = uploadResult?.file ?? null;
    //   }
    // } catch (err) {
    //   console.log("ถ่าย/อัปโหลดรูปไม่สำเร็จ จะดำเนินการต่อโดยไม่แนบรูป:", err);
    // }

    onConfirm?.({
      weight: Number(sanitizeNumber(weight)),
      deduct: Number(sanitizeNumber(deduct)),
      net: netNumber,
      stock: calculateRemaining(stock, netNumber),
      //   imageUrl,
    });
  };

  const calculateRemaining = (stock = 0, net = 0) => {
    const result = dialogSide === "left" ? stock + net : stock - net;
    return result < 0 ? 0 : result;
  };

  // ปุ่มยืนยัน: อนุญาตเมื่อมีค่าซักช่อง และสุทธิไม่ติดลบ
  const canConfirm =
    (Number(weight) > 0 || Number(deduct) > 0) && !isNetNegative;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        กรอกน้ำหนัก
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 2 }}>
        <Grid container spacing={4} mb={5}>
          {/* กล้อง */}
          {/* <Grid item xs={12} md={12} lg={3} sx={{ display: "flex" }}>
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                border: "1px solid",
                borderColor: theme.palette.divider,
                flex: 1,
                display: "flex",
                backgroundColor: "black",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Webcam
                ref={webcamRef}
                audio={false}
                screenshotFormat="image/jpeg"
                screenshotQuality={1}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                }}
                videoConstraints={{
                  width: 1920,
                  height: 1080,
                  facingMode: "user",
                  frameRate: { ideal: 60 },
                }}
              />
            </Box>
          </Grid> */}

          {/* ฟอร์ม */}
          <Grid item xs={12} md={12} lg={8}>
            <Stack spacing={2} sx={{ pr: { md: 2 } }}>
              {/* คลัง */}
              <Box>
                <Typography fontSize={14} color="text.secondary" mb={0.5}>
                  คลัง
                </Typography>
                <TextField
                  fullWidth
                  value={formatNumber(stock)}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      fontWeight: 700,
                      fontSize: 24,
                      //   bgcolor: "action.hover",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography color="text.secondary">กก.</Typography>
                      </InputAdornment>
                    ),
                  }}
                  disabled
                />
              </Box>

              {/* รวม */}
              <Box>
                <Typography
                  variant="body2"
                  sx={{ mb: 0.5 }}
                  color="text.secondary"
                >
                  รวม
                </Typography>
                <TextField
                  fullWidth
                  value={formatNumber(weight)}
                  onFocus={() => setFocused("weight")}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      fontWeight: 700,
                      fontSize: 24,
                      bgcolor:
                        focused === "weight"
                          ? "action.hover"
                          : "background.paper",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography color="text.secondary">กก.</Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              {/* หัก */}
              <Box>
                <Typography
                  variant="body2"
                  sx={{ mb: 0.5 }}
                  color="text.secondary"
                >
                  หัก
                </Typography>
                <TextField
                  fullWidth
                  value={formatNumber(deduct)}
                  onFocus={() => setFocused("deduct")}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      fontWeight: 700,
                      fontSize: 24,
                      bgcolor:
                        focused === "deduct"
                          ? "action.hover"
                          : "background.paper",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography color="text.secondary">กก.</Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Divider />

              <Stack direction="row" spacing={2} alignItems="flex-end">
                {/* สุทธิ */}
                <Box flex={1}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.5 }}
                    color="text.secondary"
                  >
                    สุทธิ
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: 24,
                      color: isNetNegative ? "error.main" : "text.primary",
                    }}
                  >
                    {formatNumber(netNumber)}{" "}
                    <Typography component="span" color="text.secondary">
                      กก.
                    </Typography>
                  </Typography>
                  {isNetNegative && (
                    <Typography variant="caption" color="error.main">
                      สุทธิห้ามติดลบ
                    </Typography>
                  )}
                </Box>

                {/* คงเหลือ */}
                <Box flex={1}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.5 }}
                    color="text.secondary"
                  >
                    คงเหลือ
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: 24,
                    }}
                  >
                    {formatNumber(calculateRemaining(stock, netNumber))}{" "}
                    <Typography component="span" color="text.secondary">
                      กก.
                    </Typography>
                  </Typography>
                </Box>
              </Stack>
            </Stack>
          </Grid>

          {/* Keypad */}
          <Grid
            item
            xs={12}
            md={12}
            lg={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Paper elevation={0} sx={{ p: 1 }}>
              <Keypad
                value={inputValue}
                onChange={(val) => setInputValue(val)}
                onClear={() => {
                  setInputValue("0");
                  if (focused === "weight") setWeight("0");
                  if (focused === "deduct") setDeduct("0");
                }}
                onSubmit={(result) => {
                  const val = sanitizeNumber(String(result ?? ""));
                  if (focused === "deduct") {
                    setDeduct(val);
                    setFocused("weight");
                  } else {
                    setWeight(val);
                    setFocused("deduct");
                  }
                  setInputValue("0");
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 0 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={handleConfirm}
          disabled={!canConfirm}
          sx={{
            borderRadius: 0,
            py: 1.8,
            fontWeight: 700,
            bgcolor: "#1E2630",
            "&:hover": { bgcolor: "#111820" },
          }}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
}
